<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'clientStatusIcon',
    props: {
        color: String,
        title: String
    }
})
</script>

<template>
    <i :class="`traffic-${color}`"
       :title="title"
       class="fas fa-circle" />
</template>
